/* @flow */
import React, { Component } from 'react'
import update from 'immutability-helper'
import { Button, Colors } from 'react-foundation'
import Measure from 'react-measure'
import Select from 'react-select'
import ReactDataGrid from 'react-data-grid'
import CookieBanner from 'react-cookie-banner'
import { List } from 'immutable'
import 'react-select/dist/react-select.css'

import logo from './logo_white_160x.png'
import './App.css'
import {
  getAthletes,
  getPerformanceEvaluation,
  savePerformanceData,
  fetchUserData, getPerformanceEvaluations,
} from './lib/fetchService'

import Chart from './chart'
import Login from './components/login/Login'
import TimeEditor from './components/TimeEditor'

import moment from 'moment'

// const workoutExercises =
//   [
//     {
//       reps: 10,
//       movement: "weighted walking-lunge"
//     },
//     {
//       reps: 16,
//       movement: "toes-to-bars"
//     },
//     {
//       reps: 8,
//       movement: "power cleans"
//     },
//     {
//       reps: 10,
//       movement: "weighted walking-lunge"
//     },
//     {
//       reps: 16,
//       movement: "toes-to-bars"
//     },
//     {
//       reps: 8,
//       movement: "power cleans"
//     },
//     {
//       reps: 10,
//       movement: "weighted walking-lunge"
//     },
//     {
//       reps: 16,
//       movement: "bar muscle-ups"
//     },
//     {
//       reps: 8,
//       movement: "power cleans"
//     },
//     {
//       reps: 10,
//       movement: "weighted walking-lunge"
//     },
//     {
//       reps: 16,
//       movement: "bar muscle-ups"
//     },
//     {
//       reps: 8,
//       movement: "power cleans"
//     }
// ];

// const workout =
//   [{
//     rounds: 3,
//     movements: [
//       {
//         reps: 6,
//         movement: 'chest-to-bar pull-ups',
//       },
//       {
//         reps: 6,
//         movement: 'squat snatches, 95 lb',
//       },
//     ],
//   },
//   {
//     rounds: 3,
//     movements: [
//       {
//         reps: 7,
//         movement: 'chest-to-bar pull-ups',
//       },
//       {
//         reps: 5,
//         movement: 'squat snatches, 135 lb',
//       },
//     ],
//   },
//   {
//     rounds: 3,
//     movements: [
//       {
//         reps: 8,
//         movement: 'chest-to-bar pull-ups',
//       },
//       {
//         reps: 4,
//         movement: 'squat snatches, 185 lb',
//       },
//     ],
//   },
//   {
//     rounds: 3,
//     movements: [
//       {
//         reps: 9,
//         movement: 'chest-to-bar pull-ups',
//       },
//       {
//         reps: 3,
//         movement: 'squat snatches, 225 lb',
//       },
//     ],
//   },
//   {
//     rounds: 3,
//     movements: [
//       {
//         reps: 10,
//         movement: 'chest-to-bar pull-ups',
//       },
//       {
//         reps: 2,
//         movement: 'squat snatches, 245 lb',
//       },
//     ],
//   },
//   {
//     rounds: 3,
//     movements: [
//       {
//         reps: 11,
//         movement: 'chest-to-bar pull-ups',
//       },
//       {
//         reps: 1,
//         movement: 'squat snatches, 265 lb',
//       },
//     ],
//   }]

// const numberOfRepsEachRound = 220
// const numberOfExerciseEachRound = 4
// const workout =
//   [{
//     rounds: 5,
//     movements: [
//       {
//         reps: 55,
//         movement: 'deadlifts, 225 lb',
//       },
//       {
//         reps: 55,
//         movement: 'wall-ball shots, 20-lb. ball to 10-ft. target',
//       },
//       {
//         reps: 55,
//         movement: 'row for calories',
//       },
//       {
//         reps: 55,
//         movement: 'handstand push-ups',
//       },
//     ],
//   }]
// const workout = [
//   {
//     rounds: 10,
//     movements: [
//       {
//         reps: 9,
//         movement: 'thrusters, 95 lb.',
//       },
//       {
//         reps: 35,
//         movement: 'double-unders',
//       },
//     ],
//   },
// ]

const workout = [
  {
    rounds: 20,
    movements: [
      {
        reps: 15,
        movement: 'box-jumps'
      },{
        reps: 12,
        movement: 'shoulder-to-overhead'
      },{
        reps: 9,
        movement: 'toes-to-bar'
      },
    ]
  }
]

const numberOfRepsEachRound = 36 // TODO dynamic

const workoutExercises = []
workout.forEach(partial => {
  for (let i = 0; i < partial.rounds; i += 1) {
    partial.movements.forEach(movement => workoutExercises.push(movement))
  }
})

const colors = [
  '#FF4136',
  '#001f3f',
  '#F012BE',
  '#FF851B',
  '#2ECC40',
  '#3D9970',
  '#01FF70',
  '#85144b',
  '#39CCCC',
  '#7FDBFF',
  '#B10DC9',
  '#FFDC00',
  '#0074D9',
]

const createChartData = (exercises: Array<Object>) => {
  const exerciseData = []
  const roundTieBreaks = []

  let rounds = []
  workout.forEach(segment => {
    for (var i = 0; i < segment.rounds; i++) {
      rounds = rounds.concat([segment.movements])
    }
  })

  const repsPerRound = rounds.map(movements => {
    return movements.map(r => r.reps).reduce((prev, curr) => prev + curr, 0)
  })

  let totalReps = 0
  let round = 0

  exercises.forEach((exercise, exerciseIndex) => {
    const { reps, tieBreak } = exercise

    totalReps += Number(reps)
    if (totalReps >= repsPerRound[round]) {
      roundTieBreaks.push(tieBreak)
      round++
      totalReps = 0
    }

    const prevTieBreak =
      exerciseIndex > 0 ? exercises[exerciseIndex - 1].tieBreak : 0
    const movement = exerciseData.find(
      mvmnt => mvmnt.name === exercise.movement,
    )
    const data = {
      reps,
      start: moment.unix(prevTieBreak).toDate(),
      end: moment.unix(tieBreak).toDate(),
    }
    if (movement) {
      movement.values.push(data)
    } else {
      exerciseData.push({
        name: exercise.movement,
        color: colors.pop(),
        values: [data],
      })
    }
  })

  const roundData = roundTieBreaks.map((tieBreak, index) => {
    if (index == 0) {
      return { start: 0, end: tieBreak, round: index + 1 }
    } else {
      return {
        start: roundTieBreaks[index - 1],
        end: tieBreak,
        round: index + 1,
      }
    }
  })

  console.log(exerciseData)

  console.log(roundTieBreaks)

  return { exerciseData, roundData: roundTieBreaks }
}

const TimeFormatter = props => (
  <div style={{ color: 'blue' }}>{`${Math.floor(
    props.value / 60,
  )}' ${props.value % 60}"`}</div>
)
TimeFormatter.propTypes = {
  value: React.PropTypes.number.isRequired,
}

const RepFormatter = props => <div style={{ color: 'blue' }}>{props.value}</div>
RepFormatter.propTypes = {
  value: React.PropTypes.number.isRequired,
}

const tieBreakEditor = <TimeEditor />

const createInitialExerciseState = () => {
  const nextExercise = workoutExercises[0]
  const tieBreak = '0'
  const exercise = { ...nextExercise, tieBreak }
  return [].concat([exercise])
}

class App extends Component {
  state = {
    drawDiagram: false,
    token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
    selectedAthlete: null,
    message: null,
    role: null,
    login: false,
    evaluations: [],
    athletes: [],
    exercises: localStorage.getItem('exercises')
      ? JSON.parse(localStorage.getItem('exercises'))
      : createInitialExerciseState(),
    dimensions: {
      width: -1,
      height: -1,
    },
    columns: [
      { key: 'round', name: 'Round' },
      { key: 'reps', name: 'Reps', editable: true, formatter: RepFormatter },
      { key: 'totalReps', name: 'Total Reps' },
      { key: 'movement', name: 'Movement' },
      {
        key: 'tieBreak',
        name: 'Tiebreak',
        editable: true,
        formatter: TimeFormatter,
        editor: tieBreakEditor,
      },
      { key: 'tfm', name: 'total' },
      { key: 'tpr', name: 'average' },
    ],
  }

  componentDidMount = () => {
    // if (localStorage.getItem('exercises')) {
    //   this.setState({ exercises: JSON.parse(localStorage.getItem('exercises')) })
    // }
    if (this.state.token) {
      this.checkRoles(this.state.token)
    }
  }

  setLoginToken = token => {
    localStorage.setItem('id_token', token)
    this.checkRoles(token)
  }

  checkRoles = async token => {
    console.log(token)
    const newState = { token }
    try {
      const userData = await fetchUserData(token)
      newState.userEmail = userData.emailCanonical
      newState.login = false
      newState.selectedAthlete = userData.id
      const evaluations = await getPerformanceEvaluations(userData.id)
      newState.evaluations = evaluations['hydra:member']
      this.setState(newState)
      this.selectAthlete({ value: newState.selectedAthlete })
    } catch (err) {
      this.setState({ token: null, roles: null })
    }
  }

  rowGetter = i => {
    return this.getRows()[i]
  }

  groupMovements = exercises => {
    return exercises.reduce((prev, curr, index) => {
      if (prev.length && curr.movement === prev[prev.length - 1][0].movement) {
        prev[prev.length - 1].push({ ...curr, index })
      } else {
        prev.push([{ ...curr, index }])
      }
      return prev
    }, [])
  }

  flattenMovements = grouped => {
    return List(
      grouped.map(exercises => {
        const exercise = { ...exercises[0] }
        exercise.reps = exercises
          .map(e => Number(e.reps))
          .reduce((prev, curr) => prev + curr, 0)
        return exercise
      }),
    )
  }

  promptForMovement = () => {
    const nextExercise = this.getNextExercise()
    this.setState({ nextReps: nextExercise.reps, promptForExercise: true })
  }

  getNextExercise = () => {
    const { exercises } = this.state

    const groupedMovements = this.groupMovements(exercises)

    const flattenedMovements = this.flattenMovements(groupedMovements)

    const lastExercise = flattenedMovements.last()

    let nextExercise = workoutExercises[flattenedMovements.size]

    if (
      lastExercise.reps !== workoutExercises[flattenedMovements.size - 1].reps
    ) {
      nextExercise = { ...workoutExercises[flattenedMovements.size - 1] }
      nextExercise.reps -= lastExercise.reps
    }
    return nextExercise
  }

  addMovement = () => {
    const { exercises, nextReps } = this.state
    const tieBreak = 0
    const nextExercise = this.getNextExercise()
    const exercise = { ...nextExercise, tieBreak }
    this.setState({ exercises: exercises.concat([exercise]) })
  }

  checkReps = exercises => {
    const groupedMovements = this.groupMovements(exercises)

    const newMovements = groupedMovements.map((movementArray, index) => {
      const totalReps = workoutExercises[index].reps
      const repsMade = movementArray
        .map(e => Number(e.reps))
        .reduce((prev, curr) => prev + curr, 0)
      const diff = repsMade - totalReps

      if (diff < 0) {
        if (index === groupedMovements.length - 1) {
          return movementArray
        }
        const insertExercise = {
          ...movementArray[movementArray.length - 1],
          reps: -diff,
        }
        return movementArray.concat([insertExercise])
      } else if (diff > 0) {
        let newMovementArray = []

        // check how many movements to cut
        movementArray.some(movement => {
          newMovementArray.push(movement)
          const repsSoFar = newMovementArray
            .map(e => Number(e.reps))
            .reduce((prev, curr) => prev + curr, 0)
          return repsSoFar >= totalReps
        })

        const newRepsMade = newMovementArray
          .map(e => Number(e.reps))
          .reduce((prev, curr) => prev + curr, 0)
        const newDiff = newRepsMade - totalReps

        newMovementArray[newMovementArray.length - 1].reps -= newDiff

        return newMovementArray
      }
      return movementArray
    })

    const newExercises = []
    newMovements.forEach(movementArray => {
      movementArray.forEach(movement => newExercises.push(movement))
    })

    return newExercises
  }

  addMovementClickHandler = e => {
    e.preventDefault()
    this.addMovement()
  }

  drawDiagramHandler = () => {
    // console.log(createChartData(this.state.exercises))
    this.setState({ drawDiagram: true })
  }

  handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    let newState = this.state

    Object.keys(updated).forEach(key => {
      for (let i = fromRow; i <= toRow; i += 1) {
        newState = update(newState, {
          exercises: { [i]: { [key]: { $set: updated[key] } } },
        })
      }
    })

    newState.exercises = this.checkReps(newState.exercises)

    newState = update(newState, { exercises: { $set: newState.exercises } })

    localStorage.setItem('exercises', JSON.stringify(newState.exercises))
    this.setState(newState)
  }

  removeRoundClickHandler = e => {
    e.preventDefault()
    const { exercises } = this.state
    exercises.pop()
    this.setState({ exercises })
  }

  resetClickHandler = e => {
    e.preventDefault()
    this.setState({ exercises: createInitialExerciseState() })
  }

  login = () => {
    this.setState({ login: true })
  }

  saveData = () => {
    savePerformanceData(
      this.state.exercises,
      this.state.selectedAthlete,
      this.state.token,
    )
      .then(() => {
        this.setState({ message: 'Daten gespeichert' })
      })
      .catch(err => {
        this.setState({ message: err })
      })
  }

  loadEvaluationData = ({value}) => {
    const data = this.state.evaluations.find(({id}) => id === value)
    this.setState({
      message: 'Daten geladen',
      exercises: JSON.parse(data.data),
      drawDiagram: false,
    })
  }

  selectAthlete = option => {
    const id = option.value
    getPerformanceEvaluation(id, this.state.token)
      .then(res => {
        this.setState({
          message: 'Daten geladen',
          exercises: JSON.parse(res.data),
          selectedAthlete: id,
          drawDiagram: false,
        })
      })
      .catch(() => {
        this.setState({
          message: 'noch keine Daten vorhanden',
          exercises: createInitialExerciseState(),
          selectedAthlete: id,
          drawDiagram: false,
        })
      })
  }

  getRows = () => {
    const rows = this.state.exercises.map((exercise, index) => {
      const prevTieBreak =
        index > 0 ? this.state.exercises[index - 1].tieBreak : 0
      const duration = exercise.tieBreak - prevTieBreak
      const prevTotalReps = this.state.exercises
        .filter((e, i) => i < index)
        .map(e => Number(e.reps))
        .reduce((prev, reps) => prev + reps, 0)
      const totalReps = prevTotalReps + Number(exercise.reps)
      return {
        round: Math.floor(prevTotalReps / numberOfRepsEachRound) + 1,
        reps: exercise.reps,
        totalReps,
        movement: exercise.movement,
        tieBreak: exercise.tieBreak,
        tfm: `${duration}"`,
        tpr: `${Math.round(duration / exercise.reps * 100) / 100}"`,
      }
    })
    return rows
  }

  render() {
    const rows = this.getRows()
    const { width } = this.state.dimensions
    return (
      <div className="App">
        <CookieBanner
          message="Durch die Nutzung dieser Website erklären Sie sich damit einverstanden, dass sie Cookies verwendet."
          onAccept={() => {}}
          cookie="user-has-accepted-cookies"
        />
        <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>Workout Performance Analysis</h2>
        </div>
        {this.state.login && <Login onLogin={this.setLoginToken} />}
        {!this.state.login && (
          <div>
            <div className="row">
              <div className="columns small-12">
                <p>{this.state.message}</p>
              </div>
            </div>
            <div className="row">
              <div className="columns medium-4">
                {this.state.userEmail && this.state.userEmail}
                {!this.state.userEmail && (
                  <Button onClick={this.login} color={Colors.SUCCESS}>
                    Login
                  </Button>
                )}
              </div>
              <div className="columns medium-4">
                <Select
                  name="evaluations"
                  options={
                    this.state.evaluations.map(({id, createdAt}) => ({
                      value: id,
                      label: createdAt
                    }))
                  }
                  onChange={this.loadEvaluationData}
                  />
                {this.state.roles &&
                  this.state.roles.find(r => r === 'ROLE_ADMIN') && (
                    <Select
                      name="athlete"
                      value={this.state.selectedAthlete}
                      options={this.state.athletes}
                      onChange={this.selectAthlete}
                    />
                  )}
              </div>
              <div className="columns medium-4">
                {this.state.token && (
                  <Button onClick={this.saveData} color={Colors.SUCCESS}>
                    Speichern
                  </Button>
                )}
                <Button
                  onClick={this.drawDiagramHandler}
                  color={Colors.SUCCESS}
                >
                  Diagram anzeigen
                </Button>
              </div>
            </div>
            <div className="row">
              <div className="columns">
                <Button
                  onClick={this.addMovementClickHandler}
                  color={Colors.SUCCESS}
                >
                  Nächste Übung
                </Button>
                <Button
                  onClick={this.removeRoundClickHandler}
                  isHollow
                  color={Colors.WARNING}
                >
                  Übung entfernen
                </Button>
                <Button
                  onClick={this.resetClickHandler}
                  isHollow
                  color={Colors.DANGER}
                >
                  Reset
                </Button>
              </div>
            </div>
            <div className="row">
              <div className="columns large-12">
                {this.state.drawDiagram &&
                <Measure
                  onMeasure={dimensions => {
                    this.setState({ dimensions })
                  }}
                >
                  <Chart
                    width={width}
                    height="400"
                    data={createChartData(this.state.exercises)}
                  />
                </Measure>
                }
              </div>
            </div>
            <div className="row">
              <div className="columns large-12">
                <ReactDataGrid
                  columns={this.state.columns}
                  enableCellSelect
                  rowGetter={i => rows[i]}
                  rowsCount={rows.length}
                  minHeight={1000}
                  onGridRowsUpdated={this.handleGridRowsUpdated}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js